import { render } from "./AppLayout.vue?vue&type=template&id=5663af57"
import script from "./AppLayout.vue?vue&type=script&setup=true&lang=js"
export * from "./AppLayout.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/Layouts/AppLayout.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5663af57"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5663af57', __exports__)) {
    api.reload('5663af57', __exports__)
  }
  
  module.hot.accept("./AppLayout.vue?vue&type=template&id=5663af57", () => {
    api.rerender('5663af57', render)
  })

}


export default __exports__